import Button from "../../components/commons/button";
import icEdit from "../../assets/images/ic-edit-04.svg";

export const TABLE_APPROVAL_SETTING = {
    name: 'Job Title',
    column: [
        {
            name: 'Job Title',
            key: "title",
            className: 'font-semibold'
        },
        {
            name: "Approver 1",
            key: "approver_1",
        },
        {
            name: "Approver 2",
            key: "approver_2",
        },
        {
            name: "Action",
            key: "action",
            render: ({item, onClickItem}) => (
                <div className="flex gap-3 mx-auto">
                    <Button icon={icEdit} type="outline" onClick={() => onClickItem(item)}/>
                </div>
            )
        }
    ]
}

export const INITIAL_DATA_FILTER_APPROVAL = {
    search: '',
    page: 1,
    limit: 20
}
